<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12">
          <DateAndQtyDisplay/>
          <ul :hidden="true">
            <li>{{ 'list.confirmation_book_free'|globalTranslate }}</li>
            <li>{{ 'list.confirmation_free_cancelation'|globalTranslate }}</li>
            <li>{{ 'list.confirmation_order_edit'|globalTranslate }}</li>
            <li>{{ 'list.confirmation_no_deposit'|globalTranslate }}</li>
            <li>{{ 'list.confirmation_pay'|globalTranslate }}</li>
          </ul>
          <CartProductListItem v-for="(cartProduct, k) in getProductsFromCart()" :key="k" :cart-product="cartProduct"
                               :number-of-days="getNumberOfDays()" :data="data" :iteration="k"/>
          <v-divider class="my-5"></v-divider>
          <v-list-item>
            <v-list-item-title>
              <div class="d-flex align-baseline">
                <div>
                  <v-icon class="mr-2">mdi-shield-lock</v-icon>
                  {{ 'cart_warranty'|globalTranslate }}
                </div>
                <strong class="ml-auto text-h6 font-weight-bold">{{ getWarrantyTtc() }} &euro;</strong>
              </div>
            </v-list-item-title>
          </v-list-item>
          <div v-if="getSellOff()">
            <v-divider class="my-5"></v-divider>
            <v-list-item>
              <v-list-item-title>
                <div class="d-flex align-baseline red--text">
                  <div>
                    <v-icon class="mr-2">mdi-sack-percent</v-icon>
                    {{ 'cart_promo_code'|globalTranslate }}
                  </div>
                  <strong class="ml-auto text-h6 font-weight-bold">-{{ getSellOff().percent }} &percnt;</strong>
                </div>
              </v-list-item-title>
            </v-list-item>
          </div>
          <v-divider class="my-5"></v-divider>
          <v-list-item>
            <v-list-item-title>
              <div class="d-flex align-baseline">
                <div class="font-weight-bold text-uppercase">
                  {{ 'cart_total_internet'|globalTranslate }}
                </div>
                <strong class="ml-auto text-h6 font-weight-bold">{{ getTotalTtc(2) }} &euro;</strong>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-col>
      </v-row>
    </v-container>
    <div class="grey lighten-4 py-6">
      <v-container>
        <v-row justify="center">
          <v-col xs="12" md="8">
            <p class="my-6">{{ 'sentence.accordance'|globalTranslate }}</p>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                  v-model="address.lastname"
                  dense
                  outlined
                  id="address-lastname"
                  :label="'label_lastname'|globalTranslate"
                  :rules="nameRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.firstname"
                  dense
                  outlined
                  id="address-firstname"
                  :label="'label_firstname'|globalTranslate"
                  :rules="nameRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.address"
                  dense
                  outlined
                  :label="'label_address'|globalTranslate"
                  :rules="addressRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.zipcode"
                  dense
                  outlined
                  :label="'label_zipcode'|globalTranslate"
                  :rules="zipCodeRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.city"
                  dense
                  outlined
                  :label="'label_city'|globalTranslate"
                  :rules="textRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.country"
                  dense
                  outlined
                  :label="'label_country'|globalTranslate"
                  :rules="textRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.skiResortAddress"
                  dense
                  outlined
                  :label="'label_ski_resort_address'|globalTranslate"
                  :rules="addressRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.mobilePhone"
                  dense
                  outlined
                  id="address-mobile-phone"
                  :label="'label_mobile_phone'|globalTranslate"
                  :rules="phoneRules"
              ></v-text-field>
              <v-text-field
                  v-model="address.email"
                  dense
                  outlined
                  id="address-email"
                  :rules="emailRules"
                  :label="'label_email'|globalTranslate"
              ></v-text-field>
            </v-form>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <v-btn large color="primary" @click="checkout" class="font-weight-bold"
                   :disabled="getProductsFromCart() < 1 || busy">
              <v-icon left>mdi-chevron-right</v-icon>
              {{ 'infos_validate'|globalTranslate }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" :top="true" :right="true" :color="snackbarColor">{{ snackbarMsg }}
    </v-snackbar>
  </div>
</template>

<script>
import {mapState, mapGetters} from "vuex";
import snackbarMixin from "@/mixins/snackbarMixin";
import NProgress from 'nprogress';
import CartProductListItem from "@/components/CartProductListItem";
import DateAndQtyDisplay from "@/components/DateAndQtyDisplay";
import OrderService from "@/services/OrderService";

export default {
  name: "Checkout",
  beforeRouteLeave(to, from, next) {
    NProgress.start();
    this
        .$store
        .dispatch("cart/saveAddress", this.address)
        .then(() => {
          if (to.name !== 'finish') {
            this.showSnackBar("Enregistrement confirmé, redirection...", "success");
          }
          setTimeout(() => {
            next();
          }, 500);
        })
        .catch(e => {
          console.log(e);
        });
  },
  components: {CartProductListItem, DateAndQtyDisplay},
  computed: {
    ...mapState(["cart", "data"]),
    ...mapGetters({
      getProductsFromCart: "cart/getProducts",
      getNumberOfDays: "cart/getNumberOfDays",
      getWarrantyTtc: "cart/getWarrantyTtc",
      getTotalTtc: "cart/getTotalTtc",
      getSellOff: "cart/getSellOff",
      getAddress: "cart/getAddress"
    })
  },
  created() {
    this.address = this.getAddress();
  },
  data() {
    return {
      address: {},
      addressRules: [
        value => (value && value.length >= 3 || !value) || 'La longueur minimale est de 3 caractères',
        value => (value && value.length <= 200 || !value) || 'La longueur maximale est de 200 caractères',
      ],
      busy: false,
      emailRules: [
        value => !!value || 'Ce champ est requis',
        value => (value && value.length <= 200) || 'La longueur maximale est de 200 caractères',
        value => this.validEmail(value) || 'Email invalide',
      ],
      nameRules: [
        value => !!value || "Ce champ est requis",
        value => (value && value.length >= 3) || 'La longueur minimale est de 3 caractères',
        value => (value && value.length <= 50) || 'La longueur maximale est de 50 caractères',
      ],
      phoneRules: [
        value => !!value || "Ce champ est requis",
        value => (value && value.length >= 10) || 'La longueur minimale est de 10 caractères',
        value => (value && value.length <= 20) || 'La longueur maximale est de 20 caractères',
      ],
      textRules: [
        value => (value && value.length >= 3 || !value) || 'La longueur minimale est de 3 caractères',
        value => (value && value.length <= 100 || !value) || 'La longueur maximale est de 100 caractères',
      ],
      zipCodeRules: [
        value => (value && value.length <= 20 || !value) || 'La longueur maximale est de 20 caractères',
      ],
      valid: true
    }
  },
  methods: {
    checkout() {
      if(this.cart.date == new Date().toISOString().substr(0, 10)) {
        if (confirm('La date de début de votre séjour correspond à la date du jour ! Cliquez sur OK pour valider.') === false) {
          return;
        }
      }
      if (!this.$refs.form.validate()) {
        this.showSnackBar("Le formulaire comporte des erreurs !", "error");
        return;
      }
      this.busy = true;
      NProgress.start();

      this
          .$store
          .dispatch("cart/saveAddress", this.address)
          .then(() => {
            const payload = {
              ...this.address,
              products: this.cart.products.map(product => {
                return {
                  productEquipments: product.equipments.map((value, k) => {
                    // Note : value is true (equipment selected) or false
                    return value ? product.product.productEquipments[k].id.toString() : null;
                  }).filter(value => !!value),
                  product: product.product.id,
                  owner: product.owner,
                  shoeSize: product.shoeSize.id,
                  size: product.size.id,
                  weight: product.weight.id,
                }
              }),
              nbDays: this.cart.numberOfDays,
              startDate: this.cart.date,
              warranty: this.cart.warranty,
              sellOffLabel: this.cart.sellOff ? this.cart.sellOff.label : '',
            };
            return OrderService.orders(payload);
          })
          .then(() => {
            this.showSnackBar("Votre réservation a été enregistrée !");
            setTimeout(() => {
              this.$router.push('finish');
            }, 1000);
          })
          .catch(e => {
            NProgress.done();
            this.showSnackBar("Nous sommes désolés mais nous n'avons pas pu valider votre réservation.", "error");
            console.log(e);
            this.busy = false;
          });
    },
    validateForm() {
      return this.$refs.form.validate();
    },
    validEmail: email => {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }
  },
  mixins: [snackbarMixin]
}
</script>

<style scoped>

</style>
